/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Catalog_Movement_Hip_ExtensionInputs */

const en_us2_catalog_movement_hip_extension = /** @type {(inputs: Catalog_Movement_Hip_ExtensionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`hip extension`)
};

const pt_br2_catalog_movement_hip_extension = /** @type {(inputs: Catalog_Movement_Hip_ExtensionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`extensão de quadril`)
};

const es_419_catalog_movement_hip_extension = /** @type {(inputs: Catalog_Movement_Hip_ExtensionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`extensión de cadera`)
};

const pt_pt2_catalog_movement_hip_extension = /** @type {(inputs: Catalog_Movement_Hip_ExtensionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`extensão da anca`)
};

const fr_fr2_catalog_movement_hip_extension = /** @type {(inputs: Catalog_Movement_Hip_ExtensionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`extension de hanche`)
};

const de_de2_catalog_movement_hip_extension = /** @type {(inputs: Catalog_Movement_Hip_ExtensionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hüftstreckung`)
};

const it_it2_catalog_movement_hip_extension = /** @type {(inputs: Catalog_Movement_Hip_ExtensionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`estensione dell'anca`)
};

/**
* | output |
* | --- |
* | "hip extension" |
*
* @param {Catalog_Movement_Hip_ExtensionInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const catalog_movement_hip_extension = /** @type {((inputs?: Catalog_Movement_Hip_ExtensionInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Catalog_Movement_Hip_ExtensionInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_catalog_movement_hip_extension(inputs)
	if (locale === "es-419") return es_419_catalog_movement_hip_extension(inputs)
	if (locale === "pt-PT") return pt_pt2_catalog_movement_hip_extension(inputs)
	if (locale === "fr-FR") return fr_fr2_catalog_movement_hip_extension(inputs)
	if (locale === "de-DE") return de_de2_catalog_movement_hip_extension(inputs)
	if (locale === "it-IT") return it_it2_catalog_movement_hip_extension(inputs)
	return en_us2_catalog_movement_hip_extension(inputs)
});
export { catalog_movement_hip_extension as "catalog.movement.hip_extension" }